import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '../../Popup/ConfirmationModal';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { useWatchButton } from '../../WatchButton/useWatchButton';
const GroupClosedWatchModal = ({ group, popModal })=>{
    const { t } = useTranslation();
    const { biData, onClick } = useWatchButton(group);
    const onWatch = useCallback(()=>{
        onClick();
        popModal();
    }, [
        popModal,
        onClick
    ]);
    return /*#__PURE__*/ React.createElement(ConfirmationModal, {
        onCancel: popModal,
        onConfirm: onWatch,
        title: t('group.join.closed.popup.error.title'),
        text: /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", null, t('group.join.closed.popup.error.body', {
            groupname: group.username
        })), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(BiLink, {
            href: "/"
        }, t('group.join.closed.popup.link.whatIsWatch')))),
        cancelBtnLabel: t('group.join.closed.popup.button.cancel'),
        confirmBtnLabel: t('group.join.closed.popup.button.watch'),
        confirmBtnBiData: biData,
        isOpen: true
    });
};
GroupClosedWatchModal.displayName = 'GroupClosedWatchModal';
export default GroupClosedWatchModal;

//# sourceMappingURL=GroupClosedWatchModal.js.map